
import React, { useState } from "react";
import "./pagestyles/Help.css";

const Help = () => {

  const faqs = [
    {
      question: "How do I create an account?",
      answer:
        "Click on the Sign Up button and follow the registration process using your email address."
    },
    {
      question: "How do I reset my password?",
      answer:
        "Go to the login page and click on 'Forgot Password'. Follow the instructions sent to your email."
    },
    {
      question: "How can I manage my subscription?",
      answer:
        "You can manage your subscription from the Account Settings page."
    },
    {
      question: "How do I contact customer support?",
      answer:
        "You can contact our support team through the contact form or email support@example.com."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="help-container">

      <div className="help-header">
        <h1>Help Center</h1>
        <p>Find answers to common questions and get support.</p>

        <input
          type="text"
          placeholder="Search help articles..."
          className="help-search"
        />
      </div>

      <div className="help-categories">

        <div className="help-card">
          <h3>Account Help</h3>
          <p>Manage your account settings, password and profile.</p>
        </div>

        <div className="help-card">
          <h3>Subscription</h3>
          <p>Information about plans, billing and cancellations.</p>
        </div>

        <div className="help-card">
          <h3>Technical Issues</h3>
          <p>Fix login issues, website errors and troubleshooting.</p>
        </div>

        <div className="help-card">
          <h3>Privacy & Security</h3>
          <p>Learn how we protect your data and privacy.</p>
        </div>

      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>

        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
            </div>

            {activeIndex === index && (
              <div className="faq-answer">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="contact-support">
        <h2>Still Need Help?</h2>
        <p>Our support team is available to assist you.</p>

        <button className="support-btn">
          Contact Support
        </button>
      </div>

    </div>
  );
};

export default Help;